import Repository from "./Repository";

export default {
  getAllManagers() {
    return Repository.get(`managers`);
  },
};
